import { VALUE_UPDATE_EVENT } from "../../lib/constants.js";
import { getUniqueString } from "../../lib/utils.js";
import { idMap } from "../../lib/utils_vue.js";
import { Fragment, createBlock, createElementBlock, createElementVNode, createVNode, openBlock, renderList, renderSlot, resolveComponent, unref, withCtx } from "vue";
import { DtButton, DtListItem } from "@dialpad/dialtone-vue";
import { DtIconClose, DtIconPlus } from "@dialpad/dialtone-icons/vue3";
//#region src/components/controls/control_iterable.vue
var _hoisted_1 = { class: "d-fs18" };
var _hoisted_2 = { class: "d-fl-grow1" };
var _hoisted_3 = { class: "d-fs18" };
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcControlIterable" }, {
	props: {
		value: {
			type: Array,
			required: true
		},
		disabled: {
			type: Boolean,
			default: false
		},
		generateItem: {
			type: Function,
			required: true
		}
	},
	emits: [VALUE_UPDATE_EVENT],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		/**
		* Id map is used to keep v-for keys in order when adding and removing new items.
		*/
		const { addId, removeId, getId } = idMap(`${getUniqueString(`dtc-control-iterable`)}-item`);
		function updateItem(index, item) {
			const items = [...props.value];
			items.splice(index, 1, item);
			updateValue(items);
		}
		function addItem() {
			const items = [...props.value, props.generateItem()];
			addId();
			updateValue(items);
		}
		function removeItem(index) {
			const items = [...props.value];
			items.splice(index, 1);
			removeId(index);
			updateValue(items);
		}
		function updateValue(e) {
			emit(VALUE_UPDATE_EVENT, e);
		}
		return (_ctx, _cache) => {
			const _component_dt_stack = resolveComponent("dt-stack");
			return openBlock(), createElementBlock("div", null, [
				createElementVNode("div", null, [renderSlot(_ctx.$slots, "default")]),
				createElementVNode("div", _hoisted_1, [renderSlot(_ctx.$slots, "prefix")]),
				createElementVNode("div", null, [(openBlock(true), createElementBlock(Fragment, null, renderList(__props.value, (item, index) => {
					return openBlock(), createBlock(_component_dt_stack, {
						key: unref(getId)(index),
						direction: "row",
						class: "d-my1"
					}, {
						default: withCtx(() => [createElementVNode("div", _hoisted_2, [createVNode(unref(DtListItem), {
							class: "d-p6 d-pl0",
							"navigation-type": "tab",
							type: "custom"
						}, {
							default: withCtx(() => [renderSlot(_ctx.$slots, "item", {
								item,
								update: (e) => updateItem(index, e)
							})]),
							_: 2
						}, 1024)]), createElementVNode("div", null, [createVNode(unref(DtButton), {
							class: "dtc-icon d-px0 d-py6 d-ps-relative d-t6",
							importance: "clear",
							size: "xs",
							disabled: __props.disabled,
							onClick: () => removeItem(index)
						}, {
							default: withCtx(() => [createVNode(unref(DtIconClose))]),
							_: 1
						}, 8, ["disabled", "onClick"])])]),
						_: 2
					}, 1024);
				}), 128)), createElementVNode("div", null, [createVNode(unref(DtButton), {
					class: "dtc-icon d-p0 d-mt8",
					importance: "clear",
					disabled: __props.disabled,
					onClick: addItem
				}, {
					default: withCtx(() => [createVNode(unref(DtIconPlus))]),
					_: 1
				}, 8, ["disabled"])])]),
				createElementVNode("div", _hoisted_3, [renderSlot(_ctx.$slots, "suffix")])
			]);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=control_iterable.vue.js.map